import { Mapper } from '../../../../base/utils/mapper';
import { DetalleAtencionModel } from '../../../../domain/models/consult/detalle-atencion.model';
import { DetalleAtencionEntity } from '../entities/detalle-atencion.entity';

export class DetalleAtencionImplementationRepositoryMapper extends Mapper<DetalleAtencionEntity, DetalleAtencionModel> {
    mapFrom(param: DetalleAtencionEntity): DetalleAtencionModel {
        return {
            data: param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors: param.errors,
        };
    }
    mapTo(param: DetalleAtencionModel): DetalleAtencionEntity {
        return {
            data: param.data,
            isSuccess: param.isSuccess,
            message: param.message,
            errors: param.errors,
        };
    }
}
